import axiosInstance from '../../../helpers/backend_helper';

const getStories = async () => {
  try {
    const response = await axiosInstance.get('stories');
    return response.data;
  } catch (error) {
    console.error('Error fetching all blogs:', error);
    throw error;
  }
};

export default getStories;
